import NavBar from "../../Componants/NavBar";
import CardLage from "../../Componants/CardLage";
import Pills from "../../Componants/Pills";
import {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import AlertError from "../../Componants/AlertError";
import React from "react";
import {Ajax} from "../../Service/ajax";
import {GridLoader} from "react-spinners";
import AlertSuccess from "../../Componants/AlertSuccess";
import Footer from "../../Componants/Footer";
import {convertDate, formatNumber} from "../../config/AppConfig"
import {useMediaQuery} from "react-responsive";
import {plans, security} from "../../env/Environment";
import Swal from "sweetalert2";
export default function ApplicationView(){
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const session = sessionStorage.getItem("session");
    const solution = JSON.parse(sessionStorage.getItem("solution"));
    const application=JSON.parse(sessionStorage.getItem("application"));
    const errorInSession = sessionStorage.getItem('error');
    const company = JSON.parse(sessionStorage.getItem("company"));
    const[options, setOptions]=useState([]);
    const[informations,setInformations]=useState([]);
    const [cdfAccount, setCDFAccount] = useState({balance:0.0,incomingBalance:0.0, outgoingBalance:0.0});
    const [usdAccount, setUSDAccount] = useState({balance:0.0,incomingBalance:0.0, outgoingBalance:0.0});
    const[subscriptionPlan,setSubscriptionPlan]=useState([]);
    const [subscriptions, setSubscriptions]=useState([]);
    const [rate, setRate]=useState({positive:0, negative:0})
    const success = sessionStorage.getItem("success");
    const isMediumScreen = useMediaQuery({ maxWidth: 991 });
    const isSmallScreen = useMediaQuery({ maxWidth: 575 });
    const trf = sessionStorage.getItem("trf");
    const [isEnableOption, setIsEnableOption] = useState(true);
    const [isEnableInfo, setIsEnableInfo] = useState(true);
    const [isEnableSub, setIsEnableSub] = useState(true);
    const [devise,setDevise] = useState("CDF");
    const [transactionType,setTransactionType] = useState("PMT");
    const [transactions, setTransactions] = useState([]);
    const [reference, setReference] = useState("all");
    const [charging, setCharging] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [isLastPage, setIsLastPage] = useState(false);

    function calculateRate(objects) {
        let activeCount = 0;
        let totalCount = objects.length;

        objects.forEach(obj => {
            if (obj.status === 'ACTIVE') {
                activeCount++;
            }
        });

        const positiveRate = (activeCount / totalCount) * 100;
        const negativeRate = 100 - positiveRate;

        return { positive: positiveRate, negative: negativeRate };
    }
    const deactivatePlans= async (subs)=>{
        subs = subs.filter(sub => !(sub === plans.evaluation || sub === plans.premium || sub === plans.standard || sub === plans.business));
        try{
           const response = await Ajax.putRequest(`/api/v1/sub/subscription/deactivate/${application.organisationId}`, subs);
        }catch (error){
            console.log(error.message);
        }
    }

    useEffect(() => {
        const fetchTransactions = async () => {
            setCharging(true);
            try{
                const transaction = await Ajax.getRequest('/api/v1/trs/transactions', {
                    params: {
                        own: company.id,
                        sol: solution.id,
                        srv: 'all',
                        act: 'all',
                        ref: reference,
                        opr: transactionType,
                        slug: '',
                        crc: devise,
                        sts: transactionType === "PMT" ? "confirmed,completed" : 'all',
                        lmt: 10,
                        pge: currentPage
                    }});
                setTransactions(transaction.data.contents);
                if(transaction.data.contents && transaction.data.contents.length > 0) {
                    setIsLastPage(transaction.data.contents.length < 10);
                }
                console.log("transaction: ",transaction.data);
            }catch (error){
                console.log(error.message);
            }finally {
                setCharging(false);
            }
        }
        fetchTransactions();
    }, [devise, transactionType, reference, currentPage]);

    function formatPrice(price) {
        if (isNaN(price) || price === null || price === undefined) {
            return '0.00';
        }
        return parseFloat(price).toFixed(2);
    }

    useEffect(() => {
        const handlePageChange = async () => {
            if (!application.pageUrl) {
                let newPageUrl;
                if (application.title) {
                    newPageUrl = application.title
                        .toLowerCase()
                        .replace(/\s+/g, '-');
                    try {
                        const {data} = await Ajax.putRequest(`/api/v1/sub/application/update/page/${application.id}?newPageUrl=${newPageUrl}`);
                        if(!data.error){
                            sessionStorage.setItem("application", JSON.stringify(data.object));
                        }
                    }catch (error){
                        console.log(error.message);
                    }
                }
            }
        }
        const handleSubscription = async (trf_id) => {
            try {
                const {data}=await Ajax.putRequest(`/api/v1/sub/application/update/current-plan/${application.id}?plan_id=${trf_id}`);
            }catch (error){
                console.log(error.message);
            }
        }
        const fetchData = async (trf_id) => {
            try {
                setLoading(true);
                if (sessionStorage.getItem("application")) {
                    // Récupération des abonnements
                    const subscriptionResponse = await Ajax.getRequest(`/api/v1/sub/application/${application.id}/subscription/retrieve`);
                    let isActive ;
                    isActive = JSON.parse(trf).status === "ACTIVE";
                    const subscriptionData = subscriptionResponse.data;

                    if (subscriptionData.error) {
                        navigate("/error-page");
                    } else {
                        if (subscriptionData.object.subscriptionPlans.length > 0) {

                            const transformedPlan = subscriptionData.object.subscriptionPlans.map(item => {
                                return {
                                    id :item.id,
                                    name: item.title || "N/D",
                                    infos: item.infos,
                                    options: item.values,
                                    date_creation: item.createdDate || "N/D",
                                    price: item.price || 0,
                                    currency: item.devise || "N/D",
                                    periodicity: item.periodicity || "N/D",
                                    status: item.status || "N/D"
                                };
                            });
                            setSubscriptionPlan(transformedPlan);
                        }
                    }


                    // Récupération des options
                    const optionsResponse = await Ajax.getRequest(`/api/v1/sub/application/${application.id}/options/retrieve`);
                    const optionsData = optionsResponse.data.object;
                    setOptions(optionsData);

                    // Récupération des informations
                    const informationsResponse = await Ajax.getRequest(`/api/v1/sub/application/${application.id}/informations/retrieve`);
                    const informationsData = informationsResponse.data.object;
                    setInformations(informationsData)

                    // Récupération du compte USD
                    const usdAccountResponse = await Ajax.getRequest('/api/v1/trs/accounts', { params: { crc: "USD", own: application.organisationId } });
                    const usdAccountData = usdAccountResponse.data;
                    setUSDAccount(usdAccountData);

                    // Récupération du compte CDF
                    const cdfAccountResponse = await Ajax.getRequest('/api/v1/trs/accounts', { params: { crc: "CDF", own: application.organisationId } });
                    const cdfAccountData = cdfAccountResponse.data;
                    setCDFAccount(cdfAccountData);

                    const {data} = await Ajax.getRequest(`/api/v1/sub/subscription/cmp/retrieve/${application.organisationId}`);
                    if (data.object.length > 0) {
                        setRate(calculateRate(data.object));

                        // Récupération des clients (IDs)
                        const clientIds = data.object.map(item => item.client);

                        // Récupération des profils des clients
                        const clientProfiles = await Promise.all(
                            clientIds.map(id => Ajax.getRequest(`/api/v1/usr/users/${id}/phone`))
                        );

                        // Création d'un mapping { clientId: fullNumber }
                        const clientNumbers = clientProfiles.reduce((acc, response, index) => {
                            const profileData = response.data; // L'objet du profil
                            acc[clientIds[index]] = profileData.fullNumber || "N/A"; // Associe fullNumber au clientId
                            return acc;
                        }, {});


                        // Transformation des abonnements avec ajout de fullNumber
                        const transformedSub = data.object.map(item => ({
                            id: item.id,
                            name: item.name,
                            subscription: item.subscription,
                            price: item.crc + "" + item.price,
                            periodicity: item.periodicity,
                            start_time: convertDate(item.start_time),
                            end_time: convertDate(item.end_time),
                            status: item.status,
                            client: item.client,
                            fullNumber: clientNumbers[item.client] || "N/A" // Associer le fullNumber récupéré
                        }));
                        setSubscriptions(transformedSub);
                    }

                } else {
                    navigate("/organisation");
                }
            } catch (error) {
                navigate("/error-page", { state: { errorCode: error.response.status } });
            }finally {
                setLoading(false);
            }
        };
        if (session && trf) {
            fetchData(JSON.parse(trf).id);
            handlePageChange();
            handleSubscription(JSON.parse(trf).id);
        }else{
            navigate('/');
        }
    }, []);

    return(
        <>
            {loading ? (
                    <div className="loading-overlay">
                        <div className="loading-spinner">
                            <GridLoader
                                color="#debf66"
                                loading
                                size={15}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="layout-wrapper layout-content-navbar layout-without-menu">
                <div className="layout-container">
                    <div className="layout-page">
                        <NavBar route={"Particulier"}/>
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 container-p-y">
                                {errorInSession && <AlertError/>}
                                {success && <AlertSuccess/>}
                                <div className="row">
                                    <div className="col-lg-8">
                                        <CardLage
                                            title={application.title}
                                            subtitle={"Créer et modifier votre application de façon à la personnaliser selon vos attentes"} enlInfo={isEnableInfo} enlOp={isEnableOption} enlSub={isEnableSub} nbInfo={informations.length} nbOp={options.length} trf={JSON.parse(trf).id}
                                        />
                                    </div>
                                    <div className="col-lg-4 col-sm-6 mb-4">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between">
                                                    <div className="card-info">
                                                        <p className="card-text">Subscription Rate</p>
                                                        <div className="d-flex align-items-end mb-4">
                                                            <h4 className="card-title mb-1 me-2">{rate.positive.toFixed(0)}%</h4>
                                                            <small className="text-danger">({rate.negative.toFixed(0)}%)</small>
                                                        </div>
                                                        <small>Taux d'abonnement actifs</small>
                                                    </div>
                                                    <div className="card-icon">
                                                        <span className="badge bg-label-danger rounded p-2">
                                                          <i className="bx bx-pie-chart-alt bx-sm"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card mb-4">
                                            <div className="card-widget-separator-wrapper">
                                                <div className="card-body card-widget-separator">
                                                    <div className="row gy-4 gy-sm-1">
                                                        <div className="col-sm-6 col-lg-3">
                                                            <div className={`d-flex justify-content-between align-items-start card-widget-2 ${!isMediumScreen && !isSmallScreen ? 'border-end' : ''} pb-3 pb-sm-0`}>
                                                                <div>
                                                                    <h3 className="mb-1">{subscriptions.length}</h3>
                                                                    <p className="mb-4">Clients</p>
                                                                </div>
                                                                <span className="badge bg-label-info rounded p-2 me-sm-4">
                                                                      <i className="bx bx-user bx-sm"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-lg-3">
                                                            <div className={`d-flex justify-content-between align-items-start card-widget-2 ${!isMediumScreen && !isSmallScreen ? 'border-end' : ''} pb-3 pb-sm-0`}>
                                                                <div>
                                                                    <h3 className="mb-1">${formatPrice(usdAccount.balance)}</h3>
                                                                    <p className="mb-0">USD Solde</p>

                                                                    <div className="d-flex align-items-center mt-2" style={{ fontSize: '0.85rem' }}>
                                                                      <span className="text-danger d-flex align-items-center">
                                                                        <i className="bx bx-arrow-from-top me-1"></i>
                                                                        -${formatPrice(usdAccount.outgoingBalance)} Sortant
                                                                      </span>
                                                                    </div>
                                                                </div>

                                                                <span className="badge bg-label-success rounded p-2 me-sm-4">
                                                                    <i className="bx bx-dollar bx-sm"></i>
                                                                  </span>
                                                            </div>

                                                        </div>
                                                        <div className="col-sm-6 col-lg-3">
                                                            <div className={`d-flex justify-content-between align-items-start card-widget-2 ${!isMediumScreen && !isSmallScreen ? 'border-end' : ''} pb-3 pb-sm-0`}>
                                                                <div>
                                                                    <h3 className="mb-1">CDF{formatPrice(cdfAccount.balance)}</h3>
                                                                    <p className="mb-0">CDF Solde</p>

                                                                    <div className="d-flex align-items-center mt-2" style={{ fontSize: '0.85rem' }}>
                                                                      <span className="text-danger d-flex align-items-center">
                                                                        <i className="bx bx-arrow-from-top me-1"></i>
                                                                        -CDF{formatPrice(cdfAccount.outgoingBalance)} Sortant
                                                                      </span>
                                                                    </div>
                                                                </div>
                                                                <span className="badge bg-label-success rounded p-2 me-sm-4">
                                                                  <i className="bx bx-wallet bx-sm"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-lg-3">
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-netikash d-flex align-items-center h-px-50"
                                                                    onClick={() => navigate("/withdrawal-request", {state: {company}})}
                                                                >
                                                                    <i className="bx bx-wallet me-2"></i> EFFECTUER UN RETRAIT
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Pills subscriptionPlans={subscriptionPlan} options={options} infos={informations}
                                       subscriptins={subscriptions} transactions={transactions}
                                       devise={devise} transactionType={transactionType} setTransactionType={setTransactionType}
                                       setDevise={setDevise} reference={reference} setReference={setReference} charging={charging} currentPage={currentPage} setCurrentPage={setCurrentPage} isLastPage={isLastPage}/>
                            </div>

                            <div className="content-backdrop fade"></div>
                        </div>
                        <Footer/>
                    </div>
                </div>
                    </div>
            )}
        </>
    );
}